module.exports = __webpack_public_path__ + "resources/img/bg_banner_ncc_m.87df360722ece829a6cbcfa6207e9ae1.png";